module.exports = __webpack_public_path__ + "img/magento-security-services@2x.ca20ce86.jpeg";